import { WizardWrapper } from 'pages/style';
import React, { useEffect, useState } from 'react';
import { useCompanyId } from 'utility/useCompanyId';

import { OrganizationsApi } from 'api/api';
import { Form, Spin, Button, Input } from 'antd';
import openNotificationWithIcon from 'utility/notification';
import { useTranslation } from 'react-i18next';
import { BasicFormWrapper } from 'container/styled';
import { LocalStorageKeys } from 'hooks/useLocalStorage';
import { useLocalStorage } from 'hooks/useLocalStorage';

const organizationsApi = new OrganizationsApi();

const OrganizationProfile = ({ type }: any) => {
  const { t } = useTranslation();

  const [form] = Form.useForm();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isFinished, setIsFinished] = useState<boolean>(false);
  const [user, , , , updateNestedValue] = useLocalStorage(LocalStorageKeys.user, null);

  const companyId = useCompanyId();

  const fetchCompanyDetails = async () => {
    try {
      setIsLoading(true);
      const response = (
        await organizationsApi.apiOrganizationsIdMeGet({
          id: companyId,
        })
      ).data;
      form.setFieldsValue(response);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };

  const onFinish = async () => {
    setIsFinished(true);
    try {
      const values = await form.getFieldsValue();
      await organizationsApi.apiOrganizationsIdMePut({
        id: companyId,
        updateOrganizationCommand: {
          id: companyId,
          ...values,
        },
      });
      updateNestedValue(['organization', 'name'], values.name);
      openNotificationWithIcon(
        'success',
        t('create-company:company-edited-successfully', 'Company information are edited successfuly!'),
      );
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } catch (error) {
    } finally {
      setIsFinished(false);
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, []);

  return (
    <BasicFormWrapper style={{ width: '50%', maxWidth: 1200 }}>
      <Form layout="vertical" form={form} name="organization" onFinish={onFinish}>
        {isLoading ? (
          <div style={{ display: 'flex', height: 400, width: '100%', justifyContent: 'center', alignItems: 'center' }}>
            <Spin />
          </div>
        ) : (
          <>
            <Form.Item
              name="name"
              label={t('global:name', 'Organization Name')}
              rules={[{ required: true, message: t('validations:name.required', 'Name is required') }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="email"
              label={t('signUp.emailLabel', 'Email Address')}
              rules={[
                {
                  required: true,
                  message: t('signUp.emailRequired', 'Please input your email!'),
                  type: 'email',
                },
              ]}
            >
              <Input placeholder={t('signUp.emailPlaceholder', 'name@example.com')} />
            </Form.Item>

            <Form.Item
              name="phoneNumber"
              label={t('organizations:phone', 'Phone Number')}
              rules={[{ required: true, message: t('validations:phone.required', 'Phone number is required') }]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name="address"
              label={t('organizations:address', 'Address')}
              rules={[{ required: true, message: t('validations:address.required', 'Address is required') }]}
            >
              <Input.TextArea rows={4} />
            </Form.Item>

            <Button
              style={{ marginTop: 20 }}
              type="primary"
              size="large"
              onClick={() => form.submit()}
              loading={isFinished}
            >
              {t('global:save', 'Save')}
            </Button>
          </>
        )}
      </Form>
    </BasicFormWrapper>
  );
};

export default OrganizationProfile;
